export const EMPTY_SEGMENT_MODEL = {
  name: null,
  type: 'DYNAMIC',
  ruleSet: {
    matchType: 'OR',
    groups: []
  }
}